import { render, staticRenderFns } from "./IssueReportPackageNameCreateDone.vue?vue&type=template&id=4b2fc8a5&scoped=true&"
var script = {}
import style0 from "./IssueReportPackageNameCreateDone.vue?vue&type=style&index=0&id=4b2fc8a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2fc8a5",
  null
  
)

export default component.exports